import axios from "axios"
import {LocationInterface} from "../redux/vehicles/vehicles.type";


async function getEcoDrivingScoreByIdApi(data: LocationInterface) {
    function query() {
        const {start_date, end_date} = data;
        if (!data.vehicle_id && !data.start_date && !data.end_date) return "";
        let query = "?";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/eco-driving/vehicles/${data.vehicle_id}/scores${query()}`,
    })
}

async function getEcoDrivingGlobalSetting() {
    return axios({
        method: "GET",
        url: `/api/v1/eco-driving/vehicles-settings-global`,
    })
}

async function getEcoDrivingVehicleSetting(id:number) {
    return axios({
        method: "GET",
        url: `/api/v1/eco-driving/vehicles/${id}/settings`,
    })
}

async function postVehicleEcoDrivingSettingApi(vehicleId: string, data: any){
    return axios({
        method: "POST",
        url: `/api/v1/eco-driving/vehicles/${vehicleId}/settings`,
        data
    })
}

async function putVehicleEcoDrivingSettingApi(uuid:string, vehicleId: string, data: any){
    return axios({
        method: "PUT",
        url: `/api/v1/eco-driving/vehicles/${vehicleId}/settings/${uuid}`,
        data
    })
}

export {
    getEcoDrivingScoreByIdApi,
    getEcoDrivingGlobalSetting,
    getEcoDrivingVehicleSetting,
    postVehicleEcoDrivingSettingApi,
    putVehicleEcoDrivingSettingApi
}